// import React from 'react'
// import { makeStyles } from '@material-ui/core/styles'

// const useStyles = makeStyles({
//     testimonialSection: {
//         paddingTop: "80px",
//         paddingBottom: "80px",
//         backgroundColor: "var(--primary-color)",
//         color: "white",
//         '@media screen and (max-width: 768px)': {
//             paddingTop: '60px',
//             paddingBottom: '60px',
//         },
//         '@media screen and (max-width: 480px)': {
//             paddingTop: '50px',
//             paddingBottom: '20px',
//         },
//     },
//     testimonialHeader: {
//         textAlign: "center",
//     },
//     testimonialBody: {
//         paddingTop: "30px",
//         paddingBottom: "30px",
//     },
//     testimonialVideo: {
//         '& video': {
//             position:'absolute', 
//             top:0, 
//             left:0, 
//             width:'100%', 
//             height:'100%', 
//             objectFit: 'cover'
//         }
//     }
// })

// function Testimonials() {

//     var classes = useStyles()

//     return (
//         <div className={classes.testimonialSection}>
//             <div className="container">
//                 <div className={classes.testimonialHeader}>
//                     <h1>Hear from our Learners</h1>
//                     <p>Experiences shared by people who attended our previous program</p>
//                 </div>
//                 <div className={classes.testimonialBody}>
//                     <div className="row" style={{justifyContent: 'center'}}>
//                         <div className="col-md-4 col-6 mb-3">
//                             <div className={classes.testimonialVideo}>
//                                 <div style={{padding:'100% 0 0 0', position:'relative'}}>
//                                     <video controls style={{objectPosition: '0 30%'}}>
//                                         <source src="videos/testimonial3.mp4" type="video/mp4" />
//                                         Your browser does not support the video tag.
//                                     </video>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="col-md-4 col-6 mb-3">
//                             <div className={classes.testimonialVideo}>
//                                 <div style={{padding:'100% 0 0 0', position:'relative'}}>
//                                     <video controls style={{objectPosition: '0 20%'}}>
//                                         <source src="videos/testimonial2.mp4" type="video/mp4" />
//                                         Your browser does not support the video tag.
//                                     </video>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="col-md-4 col-6 mb-3">
//                             <div className={classes.testimonialVideo}>
//                                 <div style={{padding:'100% 0 0 0', position:'relative'}}>
//                                     <video controls style={{objectPosition: '30% 0'}}>
//                                         <source src="videos/testimonial1.mp4" type="video/mp4" />
//                                         Your browser does not support the video tag.
//                                     </video>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Testimonials
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextTestimonial from './TextTestimonial'; // Import the new component

const useStyles = makeStyles({
    testimonialSection: {
        paddingTop: "80px",
        paddingBottom: "80px",
        backgroundColor: "var(--primary-color)",
        color: "white",
        '@media screen and (max-width: 768px)': {
            paddingTop: '60px',
            paddingBottom: '60px',
        },
        '@media screen and (max-width: 480px)': {
            paddingTop: '50px',
            paddingBottom: '20px',
        },
    },
    testimonialHeader: {
        textAlign: "center",
    },
    testimonialBody: {
        paddingTop: "30px",
        paddingBottom: "30px",
    },
});

function Testimonials() {
    const classes = useStyles();

    return (
        <div className={classes.testimonialSection}>
            <div className="container">
                <div className={classes.testimonialHeader}>
                    <h1>Hear from our Learners</h1>
                    <p>Experiences shared by people who attended our previous program</p>
                </div>
                <div className={classes.testimonialBody}>
                    <div className="row" style={{ justifyContent: 'center' }}>
                        {/* Replace video testimonials with text testimonials */}
                        <div className="col-md-4 col-sm-6 mb-3">
                            <TextTestimonial text="A very interesting and valuable experience. I learnt a lot and it gave me a good grip of the fundamentals. It really made me think beyond, and enabled me to interact with people through the practical exposure" author="Meet Gadam" />
                        </div>
                        <div className="col-md-4 col-sm-6 mb-3">
                            <TextTestimonial text="In this online mode of interaction, such a session was really necessary to keep our stamina up as it was too interactive and informative which taught us Teamwork and Time management skills by assigning us some smiple tasks." author="Kush Shah" />
                        </div>
                        <div className="col-md-4 col-sm-6 mb-3">
                            <TextTestimonial text="Brushed up my existing skills and learned new ones that will enhance Creative as well as Leadership thinking. I enjoyed the workshop and I'm really interested to attend more such workshops" author="Kunjal Badrakiya" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Testimonials;
